import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Grid, Button } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import { createAgenceWithdrawal, getUserInfos, } from 'firebaseHelpers/users'
import { login, showModal, hideModal, showSnackbar, } from 'actions'
import { useDispatch, useSelector, } from 'react-redux';
import { Search, } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap'
  },
  search: {
    flexGrow: 1,
    maxWidth: 480,
    flexBasis: 480
  },
  filterButton: {
    marginLeft: 'auto'
  },
  filterIcon: {
    marginRight: theme.spacing(1)
  }
}));

const SearchBar = props => {
  const { filterComponent, showSearchInput, onFilter, onSearch, className, withdrawMoney, fetchAgenceWithdrawals, ...rest } = props;
  const FilterComponent = filterComponent
  const classes = useStyles();
  const dispatch = useDispatch();
  const session = useSelector(state => state.session);
  const [withdrawLoading, setWithdrawLoading] = useState(false)
  const [openFilter, setOpenFilter] = useState(false)

  const handleFilterOpen = () => {
    setOpenFilter(true)
  };

  const handleFilterClose = () => {
    setOpenFilter(false)
  };

  const handleValidateWithdrawal = () => {
    const handleWithdrawMoney = async () => {
      try {
        dispatch(hideModal())
        setWithdrawLoading(true)
        await createAgenceWithdrawal(session.user, withdrawMoney)
        const userInfos = await getUserInfos(session.user.id)
        dispatch(login({ ...userInfos }))
        setWithdrawLoading(false)
        dispatch(showSnackbar({ variant: 'success', message: 'Withdraw Processed successfully' }))
      } catch (error) {
        console.log(error)
        setWithdrawLoading(false)
        dispatch(showSnackbar({ variant: 'error', message: error.message }))
      }
    }
    
    if (!withdrawLoading) {
      dispatch(showModal({
        title: 'Confirmation',
        message: `Do you really want to withdraw ${withdrawMoney} AED?`,
        buttons: [
          {
            label: 'No',
            callback: () => { dispatch(hideModal()) }
          },
          {
            label: 'Yes',
            callback: handleWithdrawMoney,
          },
        ]
      }))
    }
  }

  return (
    <Grid
      {...rest}
      className={clsx(classes.root, className)}
      container
      spacing={3}
    >
      {session.user.roles === 'agence' && withdrawMoney > 0 && <Grid item>
        <Button
          className={classes.filterButton}
          color="primary"
          onClick={handleValidateWithdrawal}
          size="small"
          variant="outlined"
        >
        Ask Withdrawal
        </Button>
      </Grid>}
      <Grid item>
        {showSearchInput && (
          <Search
            className={classes.search}
            onSearch={onSearch}
          />
        )}
      </Grid>
      <Grid item>
        <Button
          className={classes.filterButton}
          color="primary"
          onClick={handleFilterOpen}
          size="small"
          variant="outlined"
        >
          <FilterListIcon className={classes.filterIcon} /> Show filters
        </Button>
      </Grid>
      <FilterComponent
        onClose={handleFilterClose}
        onFilter={onFilter}
        open={openFilter}
      />
    </Grid>
  );
};

SearchBar.propTypes = {
  showSearchInput: PropTypes.bool,
  filterComponent: PropTypes.any,
  className: PropTypes.string,
  onFilter: PropTypes.func,
  onSearch: PropTypes.func
};

export default SearchBar;
